import React, { Component } from "react";

class Popup extends Component {
	static slug = "urm-popup";
	render() {
		if (this.props.__render_popup) {
			return (
				<div
					dangerouslySetInnerHTML={{
						__html: this.props.__render_popup
					}}
				></div>
			);
		}
		return null;
	}
}

export default Popup;
